import { Content } from "./Content";
import { Header } from "./Header";
import { Root } from "./Root";

export const CollapsibleSection = Object.assign(Root, {
  Header,
  Content,
});
